import { render, staticRenderFns } from "./kematian.vue?vue&type=template&id=3b732138&scoped=true&"
import script from "./kematian.vue?vue&type=script&lang=js&"
export * from "./kematian.vue?vue&type=script&lang=js&"
import style0 from "./kematian.vue?vue&type=style&index=0&id=3b732138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b732138",
  null
  
)

export default component.exports